module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAiCAMAAADBAMEbAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF2Ori0ebd6vPtytfQ29zc9PX1x9DKzd3V5+foz+LZ/Pz84e/n5O/p0dHR////3u7ppTOMCAAAANtJREFUeNqc1NsSgyAMBNAlGtQG4f//tgFspxfbst0Z3zwbnDgg55zMkojksaA+pSV4ABQzky8FVYRylnA0wFrk1vJZnEW6kGEQMiuKdZHGBbowWoyD9iG4r2Mk278iEOLCiqBVKHGqkqogFuipIjEA6sKoGckFBfzPArOOYwYn/H1mHe3PYgUUyp2qCLgF1hmkCAojZwhs4z7dsO57jNO0LMvmN9rAkCoeEqtuvhWcVbyIt8R4lPQaL4Ku6zzv45lx3NiqTt3+1HfxlIv2gl7xXHIu8scaz1WAAQAhKVgclfFzFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/ND.png
// module id = s9Yh
// module chunks = 1